/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {saveAs} from 'file-saver'
import FromToPicker from '../BaseComponent/FromToPicker'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'

class ReportUsers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      fromDate: '',
      toDate: ''
    }
  }
  componentDidMount() {}

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }

  toDate(props) {
    return <input className="form-control" {...props} />
  }

  submit(e) {
    e.preventDefault()
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getPDF() {
    // var minDate =document.getElementById('selectedDateFrom').value;
    // var maxDate =document.getElementById('selectedDateTo').value;

    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    var name = document.getElementById('name').value
    var tId = document.getElementById('transactionId').value
    var iId = document.getElementById('invoiceId').value
    var pId = document.getElementById('paymentId').value
    var amountMin = document.getElementById('totalMin').value
    var amountMax = document.getElementById('totalMax').value
    if (maxDate == '' && minDate) {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/transactions/filter?fromTime=${minDate}&toTime=${maxDate}&name=${name}&tid=${tId}&pid=${pId}&iid=${iId}&amountMax=${amountMax}&amountMin=${amountMin}`
      )
    }
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>عمومی</li>
            <li>گزارش تراکنش کاربران</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش تراکنش کاربر</p>
            </div>

            <FromToPicker
              onChangeFromDate={this.handleChangeFromDate}
              onChangeToDate={this.handleChangeToDate}
              fromLabel="تاریخ  از"
              toLabel="تاریخ  تا"
              force={true}
              defaulValue={true}
              fromId="from"
              toId="to"
            />

            <div className="formComponent">
              {/*<label>تاریخ شروع :<span className='requireFiled'>*</span></label>*/}
              {/*<MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">*/}
              {/*<DatePicker*/}
              {/*okLabel="تأیید"*/}
              {/*cancelLabel="لغو"*/}
              {/*autoOk={true}*/}
              {/*leftArrowIcon={<Icon type="left"/>}*/}
              {/*rightArrowIcon={<Icon type="right"/>}*/}
              {/*labelFunc={date => (date ? date.format('jYYYY/jMM/jDD') : '')}*/}
              {/*onChange={this.changeFromDate}*/}
              {/*TextFieldComponent={this.fromDate}*/}
              {/*id="selectedDateFrom"*/}
              {/*name='selectedDateFrom'*/}
              {/*value={selectedDateFrom}*/}

              {/*ref={(node) => this.toDateInput = node}*/}
              {/*/>*/}
              {/*</MuiPickersUtilsProvider>*/}

              {/*<label>تاریخ پایان :<span className='requireFiled'>*</span></label>*/}
              {/*<MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">*/}
              {/*<DatePicker*/}
              {/*okLabel="تأیید"*/}
              {/*cancelLabel="لغو"*/}
              {/*autoOk={true}*/}
              {/*leftArrowIcon={<Icon type="left"/>}*/}
              {/*rightArrowIcon={<Icon type="right"/>}*/}
              {/*labelFunc={date => (date ? date.format('jYYYY/jMM/jDD') : '')}*/}
              {/*onChange={this.changeToDate}*/}
              {/*TextFieldComponent={this.toDate}*/}
              {/*id="selectedDateTo"*/}
              {/*name='selectedDateTo'*/}
              {/*value={selectedDateTo}*/}
              {/*ref={(node) => this.toDateInput = node}*/}
              {/*/>*/}
              {/*</MuiPickersUtilsProvider>*/}

              <label>نام</label>
              <input type="text" className="form-control" id="name" />

              <label>شناسه تراکنش</label>
              <input type="text" className="form-control" id="transactionId" />

              <label>شناسه فاکتور</label>
              <input type="text" className="form-control" id="invoiceId" />

              <label>شناسه پرداخت</label>
              <input type="text" className="form-control" id="paymentId" />

              <label>مبلغ تراکنش از</label>
              <input type="text" className="form-control" id="totalMin" />

              <label>مبلغ تراکنش تا</label>
              <input type="text" className="form-control" id="totalMax" />

              <button className="btn btn-info btn-block jasperBtn" onClick={this.getPDF.bind(this)}>
                گزارش تراکنش کاربران
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default ReportUsers
